import api from './api';

/**
 * Dashboard Service (Admin)
 * Handles admin dashboard API calls
 */
const dashboardService = {
    /**
     * Get dashboard statistics
     * @returns {Promise<Object>}
     */
    getStats: async () => {
        return api.get('/admin/dashboard/stats');
    }
};

export default dashboardService;
